<div class="modal-header">
	<h4 class="modal-title">Tallenna peli</h4>
	<button
		type="button"
		class="btn-close"
		aria-label="Close"
		(click)="activeModal.dismiss()"
		[disabled]="isExporting && !exportError"
	></button>
</div>
<div class="modal-body">
	<!-- Name input state -->
	<div *ngIf="showNamePrompt" class="py-3">
		<form (ngSubmit)="submitExportName()">
			<div class="mb-3">
				<label for="exportName" class="form-label"
					>Anna pelin nimi</label
				>
				<input
					type="text"
					class="form-control"
					[class.is-invalid]="showValidationErrors && validationErrors.length > 0"
					id="exportName"
					[(ngModel)]="exportName"
					(input)="onNameChange()"
					name="exportName"
					placeholder="Kuvaava nimi luomallesi pelille"
					required
					autocomplete="off"
					#nameInput
					autofocus
				/>
				<!-- Validation error messages -->
				<div *ngIf="showValidationErrors && validationErrors.length > 0" class="invalid-feedback d-block">
					<div *ngFor="let error of validationErrors" class="d-block">
						<i class="bi bi-exclamation-circle-fill me-1"></i>{{ error }}
					</div>
				</div>
				<div *ngIf="!showValidationErrors || validationErrors.length === 0" class="form-text">
					Peli tallennetaan Tallennetut-sivulle.
				</div>
			</div>

			<!-- Publish checkbox (only shown if export has no shares) -->
			<div *ngIf="!hasShares" class="mb-3">
				<div class="form-check">
					<input
						class="form-check-input"
						type="checkbox"
						id="shouldPublish"
						[(ngModel)]="shouldPublish"
						(ngModelChange)="onPublishCheckboxChange()"
						name="shouldPublish"
					/>
					<label class="form-check-label" for="shouldPublish">
						Julkaise peli
					</label>
				</div>
			</div>

			<!-- Expiry date checkbox (shown when shouldPublish is true) -->
			<div *ngIf="!hasShares && shouldPublish" class="mb-3">
				<div class="form-check">
					<input
						class="form-check-input"
						type="checkbox"
						id="hasExpiryDate"
						[(ngModel)]="hasExpiryDate"
						(ngModelChange)="onExpiryDateCheckboxChange()"
						name="hasExpiryDate"
					/>
					<label class="form-check-label" for="hasExpiryDate">
						Aseta vanhenemispäivä
					</label>
				</div>
			</div>

			<!-- Expiry date and time inputs (shown when hasExpiryDate is true) -->
			<div *ngIf="!hasShares && shouldPublish && hasExpiryDate" class="mb-3">
				<label class="form-label">Julkaisun vanhenemispäivä ja -aika</label>
				<div class="row">
					<div class="col-md-7">
						<div class="input-group">
							<input
								class="form-control"
								placeholder="pp.kk.vvvv"
								name="dp"
								[(ngModel)]="expirationDatePicker"
								(ngModelChange)="updateExpirationDateTime()"
								ngbDatepicker
								#d="ngbDatepicker"
								[displayMonths]="1"
								[firstDayOfWeek]="1"
							/>
							<button
								class="btn btn-outline-secondary bi bi-calendar3"
								(click)="d.toggle()"
								type="button"
							></button>
						</div>
					</div>
					<div class="col-md-5">
						<div class="input-group">
							<input
								type="number"
								class="form-control"
								placeholder="HH"
								name="expirationHour"
								[(ngModel)]="expirationHour"
								(ngModelChange)="updateExpirationDateTime()"
								min="0"
								max="23"
								style="max-width: 70px"
							/>
							<span class="input-group-text">:</span>
							<input
								type="number"
								class="form-control"
								placeholder="MM"
								name="expirationMinute"
								[(ngModel)]="expirationMinute"
								(ngModelChange)="updateExpirationDateTime()"
								min="0"
								max="59"
								style="max-width: 70px"
							/>
							<span class="input-group-text">
								<i class="bi bi-clock"></i>
							</span>
						</div>
					</div>
				</div>
				<small class="text-muted">Valitse päivämäärä ja kellonaika</small>
			</div>

			<button type="submit" class="d-none">Submit</button>
		</form>
	</div>

	<!-- Loading state -->
	<div *ngIf="isExporting || isPublishing" class="d-flex flex-column align-items-center py-4">
		<div class="spinner-border text-primary" role="status">
			<span class="visually-hidden">Ladataan...</span>
		</div>
		<p class="mt-3">
			{{ isPublishing ? 'Tallennetaan ja julkaistaan...' : (hasShares ? 'Tallennetaan ja päivitetään julkaisu...' : 'Tallennetaan...') }}
		</p>
	</div>

	<!-- Success state - without share -->
	<div *ngIf="exportCompleted && !exportError && !createdShare && !isPublishing" class="py-3">
		<div class="alert alert-success" role="alert">
			<i class="bi bi-check-circle-fill me-2"></i>
			Peli tallennettu Luodut pelit -näkymään.
		</div>
	</div>

	<!-- Success state - with share details -->
	<div *ngIf="exportCompleted && !exportError && createdShare" class="py-3">
		<div class="alert alert-success" role="alert">
			<i class="bi bi-check-circle-fill me-2"></i>
			Peli tallennettu ja julkaistu!
		</div>

		<!-- Share Link -->
		<div class="mb-3">
			<label class="form-label">Julkaisulinkki</label>
			<div class="input-group">
				<input
					type="text"
					class="form-control"
					[value]="GetShareURL(createdShare.uuid)"
					readonly
				/>
				<button
					class="btn btn-outline-secondary"
					(click)="copyToClipboard(GetShareURL(createdShare.uuid))"
					title="Kopioi linkki"
				>
					<i class="bi bi-clipboard"></i>
				</button>
			</div>
		</div>

		<!-- Embed Code -->
		<div class="mb-3">
			<label class="form-label">Upotuskoodi</label>
			<div class="input-group">
				<textarea
					class="form-control"
					rows="3"
					[value]="GetShareIFrameCode(createdShare.uuid)"
					readonly
				></textarea>
				<button
					class="btn btn-outline-secondary align-self-start"
					(click)="copyToClipboard(GetShareIFrameCode(createdShare.uuid))"
					title="Kopioi upotuskoodi"
				>
					<i class="bi bi-clipboard"></i>
				</button>
			</div>
		</div>
	</div>

	<!-- Error state -->
	<div *ngIf="exportError" class="py-3">
		<div class="alert alert-danger" role="alert">
			<i class="bi bi-exclamation-triangle-fill me-2"></i>
			Tallennus epäonnistui: {{ exportError }}
		</div>
	</div>
</div>
<div class="modal-footer">
	<!-- Submit name button -->
	<button
		*ngIf="showNamePrompt"
		type="button"
		class="btn btn-primary"
		(click)="submitExportName()"
		[disabled]="!isNameValid()"
	>
		{{ shouldPublish ? 'Tallenna ja julkaise' : 'Tallenna' }}
	</button>

	<!-- Show saved exports button - shown after save completes -->
	<button
		*ngIf="exportCompleted && !exportError"
		type="button"
		class="btn btn-outline-primary"
		(click)="goToExports()"
	>
		Siirry: Luodut pelit<i class="bi bi-arrow-right ms-1"></i>
	</button>

	<!-- Close button for other states -->
	<button
		*ngIf="!isExporting && !showNamePrompt"
		type="button"
		class="btn btn-secondary"
		(click)="closeModal()"
	>
		Sulje
	</button>
</div>
